import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DefaultComponent } from './default/default.component';
import { AuthGuard, Permission } from './shared/services/auth-guard.service';
import { BaselineDefinitionComponent } from './baseline-definition-details/baseline-definition.component';
import { BaselineDefinitionResolver } from './baseline-definition-details/baseline-definition.resolver';
import { RootResolver } from './default/root.resolver';
import { CreateComponent } from './create/create.component';
import { CreateBaselineResolver } from './create/create-baseline.resolver';

export enum Routing {
  doc = 'doc',
  list = 'list',
  configured = 'configured',
  create = 'create',
  history = 'history',
  root = '',
  view = 'details/:baselineDefinitionId/view-baseline-definition',
}

const routes: Routes = [
  {
    path: Routing.root,
    component: DefaultComponent,
    pathMatch: 'full',
    canActivate: [AuthGuard],
    data: { requiredPermissions: [Permission.read] },
    resolve: { data: RootResolver },
  },
  {
    path: Routing.create,
    component: CreateComponent,
    canActivate: [AuthGuard],
    data: { requiredPermissions: [Permission.create] },
    resolve: { data: CreateBaselineResolver },
  },
  {
    path: Routing.view,
    component: BaselineDefinitionComponent,
    canActivate: [AuthGuard],
    data: { requiredPermissions: [Permission.read] },
    resolve: { data: BaselineDefinitionResolver },
  },
  {
    path: Routing.doc,
    redirectTo: '/doc/index.html',
  },
  {
    path: '**',
    redirectTo: '/',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: [AuthGuard],
})
export class AppRoutingModule {}
